// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__mhL6V","title":"AfterFrontImage_title__3xSE2"};